/**
 * Dependencies.
 */
import Moment from 'moment-timezone';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

/**
 * Component.
 */
@Component({ name: 'status-fake-processing-component' })
export default class extends Vue {
  /**
   * Property `moment`.
   */
  moment = Moment;

  /**
   * Property `windowHeight`;
   */
  windowHeight = null;

  /**
   * Property `client`.
   */
  @Prop({ type: String })
  client: string;

  /**
   * Property `tracking`.
   */
  @Prop({ type: String })
  date: string;

  /**
   * Property `orderType`.
   */
  @Prop({ default: null, type: String })
  orderType: string;

  /**
   * Getter `isDelivery`
   */
  get isDelivery() {
    return this.orderType === 'DELIVERY';
  }

  /**
   * Getter processing status title.
   */
  get processingStatusTitle() {
    return this.i18n('TRACKING.SENTENCES.STATUS_HELLO', false, 'upperFirst', {
      name: this.client || '-'
    });
  }

  /**
   * Getter processing status sentence.
   */
  get processingStatusSentence() {
    const date = this.moment(this.date).format('DD MMM YYYY');

    return this.i18n(
      `TRACKING.SENTENCES.STATUS_${
        this.isDelivery ? 'DELIVERY' : 'COLLECT'
      }_FAKE_PROCESSING`,
      false,
      'plain',
      {
        date: `<b>${date || '-'}</b>`
      }
    );
  }

  /**
   * Getter `extraSmallScreenHeight`.
   */
  get extraSmallScreenHeight() {
    return this.windowHeight <= 320;
  }

  /**
   * Lifecycle mounted hook.
   */
  mounted() {
    this.handleOnResize();

    this.$nextTick(() => {
      window.addEventListener('resize', this.handleOnResize);
    });
  }

  /**
   * Lifecycle destroyed hook.
   */
  destroyed() {
    window.removeEventListener('resize', this.handleOnResize);
  }

  /**
   * Handle on resize.
   */
  handleOnResize() {
    this.windowHeight = window.innerHeight;
  }

  /**
   * Handle window height.
   */
  @Watch('windowHeight')
  handlewindowHeight(value) {
    this.windowHeight = value;
  }
}
